import React, { createRef, useEffect } from "react";
import * as styles from "./styles.module.scss";
import RichText from "../RichText";
import { useStaticQuery, graphql } from "gatsby";
import normalizeContentfulModel from "../../../normalizeContentfulModel";
import useAnalytics from "../../effects/useAnalytics";

function useAnnouncementContentfulData() {
  const data = useStaticQuery(graphql`
    query AnnouncementBar {
      allContentfulGlobal(filter: { key: { eq: "Announcement" } }) {
        nodes {
          slices {
            ... on ContentfulMultiLineText {
              key
              content: value {
                raw
              }
            }
            ... on ContentfulSingleLineText {
              key
              value
            }
            ... on ContentfulLink {
              key
              label
              url
            }
          }
        }
      }
    }
  `);
  if (data.allContentfulGlobal?.nodes[0]?.slices) {
    const { slices } = normalizeContentfulModel(
      data.allContentfulGlobal.nodes[0]
    );
    return slices;
  }
}

export default function AnnouncementBar() {
  const analytics = useAnalytics();
  const data = useAnnouncementContentfulData();

  const link = createRef();
  useEffect(() => {
    analytics.trackLink(link.current, "Clicked Announcement");
  }, [analytics, link]);

  if (data) {
    if (data.isVisible !== "visible") {
      return null;
    }

    const announcement = (
      <div className={styles.announcementBar}>
        <div className={styles.textContainer}>
          <div style={{ display: "inline-block" }}>
            {data.body && <RichText value={data.body} />}
          </div>
          <svg
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            style={{ verticalAlign: "bottom", marginLeft: "1rem" }}
            fill="#326f82"
          >
            <path d="M21.883 12l-7.527 6.235.644.765 9-7.521-9-7.479-.645.764 7.529 6.236h-21.884v1h21.883z" />
          </svg>
        </div>
      </div>
    );

    return (
      <div className={styles.container}>
        {data.cta?.url ? (
          <a href={data.cta.url} ref={link}>
            {announcement}
          </a>
        ) : (
          announcement
        )}
      </div>
    );
  }

  return null;
}
